module.exports = __webpack_public_path__ + "img/Self_Heal.2bc62208.webp";